import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useReploAgent } from "@v2/contexts/ReploAgentContext";
import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";

import { GIT_HISTORY_QUERY_KEY } from "./useGitHistory";

export function useGitRevert() {
  const {
    actions: { revertToCommit },
  } = useReploAgent();
  const projectId = useCurrentProjectId();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (sha: string) => revertToCommit({ sha }),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [GIT_HISTORY_QUERY_KEY, projectId],
      });
    },
  });

  return {
    revert: mutation.mutateAsync,
    isReverting: mutation.isPending,
  };
}
